<!-- TODO check mobile layout logic, do we want a list of left after right column or in global order -->
@if (panelFormGroup && panelConfiguration && visiblePanelConfiguration) {
  <div
    [formGroup]="panelFormGroup">
    @if (!singleColumn) {
      <div
        class="tw-flex tw-gap-5"
        [ngClass]="!isScreenSmall ? 'tw-flex-row' : 'tw-flex-col'">
        <div class="tw-flex tw-flex-col tw-flex-100" [ngClass]="!isScreenSmall && 'tw-max-w-[50%]'">
          @for (field of visiblePanelConfiguration; track field; let i = $index) {
            @if (i%2===0) {
              <gd-field-builder
                [width]="90"

                [isEditingMode]="isEditing"
                [fieldConfig]="field"
                [fieldControl]="panelFormGroup.get(field.key)"
                [hasActionPermission]="hasActionPermission"
                [usage]="usage"
                [activeLocale]="activeLocale"
                [readOnlyMode]="field.readOnly">
              </gd-field-builder>
            }
          }
        </div>
        <div class="tw-flex tw-flex-col tw-flex-100" [ngClass]="!isScreenSmall && 'tw-max-w-[50%]'">
          @for (field of visiblePanelConfiguration; track field; let i = $index) {
            @if (i%2===1) {
              <gd-field-builder
                [width]="90"
                [isEditingMode]="isEditing"
                [fieldConfig]="field"
                [fieldControl]="panelFormGroup.get(field.key)"
                [hasActionPermission]="hasActionPermission"
                [usage]="usage"
                [activeLocale]="activeLocale"
                [readOnlyMode]="field.readOnly">
              </gd-field-builder>
            }
          }
        </div>
      </div>
    }
    <!-- single column layout -->
    @if (singleColumn) {
      <div style="display: flex; flex-direction: column;">
        @for (field of visiblePanelConfiguration; track field; let i = $index) {
          <gd-field-builder [width]="90"
            [isEditingMode]="isEditing"
            [fieldConfig]="field"
            [fieldControl]="panelFormGroup.get(field.key)"
            [hasActionPermission]="hasActionPermission"
            [usage]="usage"
            [activeLocale]="activeLocale"
            [readOnlyMode]="field.readOnly">
          </gd-field-builder>
        }
      </div>
    }
  </div>
}
